var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page m-page"},[_c('div',{staticClass:"main-container"},[_c('img',{staticClass:"unselectable",attrs:{"src":"https://directimg.miaocang.cc/mpImg/wx/green_introduction@2x.png","draggable":"false","oncontextmenu":"return false;"}})])])
}]

export { render, staticRenderFns }